export enum SortMode {
  NameAscending = 'name-ascending',
  NameDescending = 'name-descending',
  Seed = 'seed'
}
